export default __webpack_public_path__ + "grabmart.png";